import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconQuestionCircle';
/** Renders an SVG icon. */
const SvgQuestionCircle = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M2 16C2 8.268 8.268 2 16 2s14 6.268 14 14-6.268 14-14 14S2 23.732 2 16M16 4C9.373 4 4 9.373 4 16s5.373 12 12 12 12-5.373 12-12S22.627 4 16 4"
      />
      <path fill="currentColor" d="M17 22a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M15 11a2 2 0 0 0-2 2 1 1 0 1 1-2 0 4 4 0 0 1 4-4h1.576c1.2 0 2.336.532 3.104 1.453l.072.088a3.9 3.9 0 0 1 .05 4.933 5.6 5.6 0 0 1-1.503 1.313l-.127.076A2.42 2.42 0 0 0 17 18.933V19a1 1 0 1 1-2 0v-.067c0-1.55.814-2.987 2.143-3.785l.127-.076c.372-.223.7-.51.97-.848a1.9 1.9 0 0 0-.024-2.403l-.073-.087A2.04 2.04 0 0 0 16.576 11z"
      />
    </svg>
  );
};
SvgQuestionCircle.displayName = displayName;
export default SvgQuestionCircle;
